import { backendGet, backendPatch, backendPost } from '../lib/backendClient';
import apiClient from '../lib/axios';

export async function getMe() {
  return await backendGet('/api/courier/me');
}

export async function updateMe(payload) {
  return await backendPatch('/api/courier/me', payload);
}

export async function getVerification() {
  return await backendGet('/api/courier/me/verification');
}

export async function uploadVerificationFace(file) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiClient.post('/api/courier/me/verification/face', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}

export async function uploadVerificationDocument(file) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiClient.post('/api/courier/me/verification/document', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}

export async function setOnline(isOnline) {
  return await backendPost('/api/courier/online', { is_online: Boolean(isOnline) });
}

export async function updateLocation(lat, lng) {
  return await backendPost('/api/courier/location', { lat, lng });
}

export async function listAvailableOrders() {
  return await backendGet('/api/courier/orders/available');
}

export async function acceptOrder(orderId) {
  return await backendPost(`/api/courier/orders/${orderId}/accept`, {});
}

export async function rejectOrder(orderId, reason = '') {
  return await backendPost(`/api/courier/orders/${orderId}/reject`, {
    reason: reason || null,
  });
}

export async function listMyOrders() {
  return await backendGet('/api/courier/orders/my');
}

export async function updateMyOrderStatus(orderId, status, code) {
  const payload = { status };
  if (code) payload.code = code;
  return await backendPatch(`/api/courier/orders/${orderId}/status`, payload);
}

export async function getPendingCashReturns() {
  return await backendGet('/api/courier/cash-returns/pending');
}

export async function confirmCashReturn(settlementId, code) {
  return await backendPost(`/api/courier/cash-returns/${settlementId}/confirm`, { code });
}
